import { call, select, takeEvery } from 'redux-saga/effects';
import {
  AngebotsId,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import dayjs from 'dayjs';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { Produkt } from '../model';
import { IAppState } from '../localStore';

export function* watchResetBeginnAblauf() {
  yield takeEvery(
    GlobalActions.RESET_BEGINN_ABLAUF,
    safeSaga(resetBeginnAblauf, App.SHOP_CHECKOUT),
  );
}

// TODO: Überprüfen in welchen Fällen benötigt
export function* resetBeginnAblauf(action: GlobalAction<AngebotsId>) {
  const globalPut = GlobalPut.getInstance();
  const { produkte }: IAppState = yield select();

  if (!isProduktAlreadyInCheckoutStore(produkte, action.payload.appId, action.payload.angebotsId)) {
    const beginnAblaufUpdateActionpayload = produkte.map(produkt => ({
      appId: produkt.appId,
      angebotsId: produkt.angebotsId,
      beginn: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
      ablauf: dayjs().add(1, 'd').add(produkt.laufzeit, 'year').format(DATEFORMAT_LOCAL_STATE),
    }));
    yield call(
      globalPut.put,
      new GlobalActions().updateBeginnAblaufOfProdukte(beginnAblaufUpdateActionpayload),
    );
  }
}

function isProduktAlreadyInCheckoutStore(
  produkte: Array<Produkt>,
  appId: App,
  angebotsId?: string,
) {
  return produkte.some(produkt => produkt.appId === appId && produkt.angebotsId === angebotsId);
}
